// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/Vazirmatn-font-face.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.16 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-x-5 {
  left: 1.25rem;
  right: 1.25rem;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.inset-y-3 {
  top: 0.75rem;
  bottom: 0.75rem;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-10 {
  bottom: -2.5rem;
}
.-bottom-5 {
  bottom: -1.25rem;
}
.-bottom-\\[50px\\] {
  bottom: -50px;
}
.-bottom-\\[60px\\] {
  bottom: -60px;
}
.-left-0\\.5 {
  left: -0.125rem;
}
.-left-6 {
  left: -1.5rem;
}
.-left-8 {
  left: -2rem;
}
.-right-6 {
  right: -1.5rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.-top-6 {
  top: -1.5rem;
}
.-top-8 {
  top: -2rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-\\[60px\\] {
  bottom: 60px;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-10 {
  left: 2.5rem;
}
.left-14 {
  left: 3.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-8 {
  left: 2rem;
}
.left-\\[0\\] {
  left: 0;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-7 {
  right: 1.75rem;
}
.right-8 {
  right: 2rem;
}
.right-\\[0px\\] {
  right: 0px;
}
.right-\\[18px\\] {
  right: 18px;
}
.right-\\[20\\%\\] {
  right: 20%;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-24 {
  top: 6rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-7 {
  top: 1.75rem;
}
.top-\\[0\\] {
  top: 0;
}
.top-\\[18px\\] {
  top: 18px;
}
.top-\\[calc\\(100\\%\\+6px\\)\\] {
  top: calc(100% + 6px);
}
.top-\\[calc\\(100\\%\\+8px\\)\\] {
  top: calc(100% + 8px);
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1\\] {
  z-index: 1;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.m-0 {
  margin: 0px;
}
.m-\\[16px\\] {
  margin: 16px;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[10px\\] {
  margin-left: 10px;
  margin-right: 10px;
}
.mx-\\[15px\\] {
  margin-left: 15px;
  margin-right: 15px;
}
.mx-\\[200px\\] {
  margin-left: 200px;
  margin-right: 200px;
}
.mx-\\[2px\\] {
  margin-left: 2px;
  margin-right: 2px;
}
.mx-\\[5px\\] {
  margin-left: 5px;
  margin-right: 5px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}
.my-\\[15px\\] {
  margin-top: 15px;
  margin-bottom: 15px;
}
.my-\\[20px\\] {
  margin-top: 20px;
  margin-bottom: 20px;
}
.my-\\[2px\\] {
  margin-top: 2px;
  margin-bottom: 2px;
}
.my-\\[5px\\] {
  margin-top: 5px;
  margin-bottom: 5px;
}
.-mb-4 {
  margin-bottom: -1rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[15px\\] {
  margin-bottom: 15px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[5px\\] {
  margin-bottom: 5px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[10px\\] {
  margin-left: 10px;
}
.ml-\\[20px\\] {
  margin-left: 20px;
}
.ml-\\[5px\\] {
  margin-left: 5px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-\\[10px\\] {
  margin-right: 10px;
}
.mr-\\[15px\\] {
  margin-right: 15px;
}
.mr-\\[20px\\] {
  margin-right: 20px;
}
.mr-\\[26px\\] {
  margin-right: 26px;
}
.mr-\\[3px\\] {
  margin-right: 3px;
}
.mr-\\[5px\\] {
  margin-right: 5px;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[15px\\] {
  margin-top: 15px;
}
.mt-\\[16px\\] {
  margin-top: 16px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[40px\\] {
  margin-top: 40px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/10\\] {
  aspect-ratio: 16/10;
}
.aspect-\\[3\\/1\\] {
  aspect-ratio: 3/1;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.\\!h-\\[22px\\] {
  height: 22px !important;
}
.\\!h-\\[76px\\] {
  height: 76px !important;
}
.\\!h-auto {
  height: auto !important;
}
.h-0 {
  height: 0px;
}
.h-1 {
  height: 0.25rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[0px\\] {
  height: 0px;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[108\\%\\] {
  height: 108%;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[130px\\] {
  height: 130px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[2\\.75rem\\] {
  height: 2.75rem;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[27px\\] {
  height: 27px;
}
.h-\\[3\\.25rem\\] {
  height: 3.25rem;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[348px\\] {
  height: 348px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[56px\\] {
  height: 56px;
}
.h-\\[5px\\] {
  height: 5px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-\\[6px\\] {
  height: 6px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[76px\\] {
  height: 76px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[82px\\] {
  height: 82px;
}
.h-\\[84px\\] {
  height: 84px;
}
.h-\\[85px\\] {
  height: 85px;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-\\[96px\\] {
  height: 96px;
}
.h-\\[min\\(560px\\2c 70vh\\)\\] {
  height: min(560px,70vh);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-44 {
  max-height: 11rem;
}
.max-h-\\[0px\\] {
  max-height: 0px;
}
.max-h-\\[1000px\\] {
  max-height: 1000px;
}
.max-h-\\[1800px\\] {
  max-height: 1800px;
}
.max-h-\\[240px\\] {
  max-height: 240px;
}
.max-h-\\[52px\\] {
  max-height: 52px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[calc\\(100vh-7rem\\)\\] {
  max-height: calc(100vh - 7rem);
}
.min-h-0 {
  min-height: 0px;
}
.min-h-4 {
  min-height: 1rem;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[150px\\] {
  min-height: 150px;
}
.min-h-\\[2\\.75rem\\] {
  min-height: 2.75rem;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[228px\\] {
  min-height: 228px;
}
.min-h-\\[28px\\] {
  min-height: 28px;
}
.min-h-\\[32px\\] {
  min-height: 32px;
}
.min-h-\\[34px\\] {
  min-height: 34px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[420px\\] {
  min-height: 420px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[52px\\] {
  min-height: 52px;
}
.min-h-\\[56px\\] {
  min-height: 56px;
}
.min-h-\\[96px\\] {
  min-height: 96px;
}
.min-h-\\[inherit\\] {
  min-height: inherit;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-\\[22px\\] {
  width: 22px !important;
}
.\\!w-\\[76px\\] {
  width: 76px !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-3\\/5 {
  width: 60%;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[108\\%\\] {
  width: 108%;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[1200px\\] {
  width: 1200px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[190px\\] {
  width: 190px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[32px\\] {
  width: 32px;
}
.w-\\[330px\\] {
  width: 330px;
}
.w-\\[340px\\] {
  width: 340px;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[35px\\] {
  width: 35px;
}
.w-\\[3px\\] {
  width: 3px;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[470px\\] {
  width: 470px;
}
.w-\\[4px\\] {
  width: 4px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[530px\\] {
  width: 530px;
}
.w-\\[55px\\] {
  width: 55px;
}
.w-\\[580px\\] {
  width: 580px;
}
.w-\\[5px\\] {
  width: 5px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[62px\\] {
  width: 62px;
}
.w-\\[64px\\] {
  width: 64px;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.w-\\[65px\\] {
  width: 65px;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[71\\%\\] {
  width: 71%;
}
.w-\\[72\\%\\] {
  width: 72%;
}
.w-\\[720px\\] {
  width: 720px;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[73\\%\\] {
  width: 73%;
}
.w-\\[76px\\] {
  width: 76px;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[84px\\] {
  width: 84px;
}
.w-\\[85px\\] {
  width: 85px;
}
.w-\\[86\\%\\] {
  width: 86%;
}
.w-\\[88px\\] {
  width: 88px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[95px\\] {
  width: 95px;
}
.w-\\[96px\\] {
  width: 96px;
}
.w-\\[min\\(480px\\2c 85vw\\)\\] {
  width: min(480px,85vw);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[2rem\\] {
  min-width: 2rem;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.min-w-\\[56px\\] {
  min-width: 56px;
}
.min-w-\\[96px\\] {
  min-width: 96px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[1120px\\] {
  max-width: 1120px;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[320px\\] {
  max-width: 320px;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[440px\\] {
  max-width: 440px;
}
.max-w-\\[5\\.5rem\\] {
  max-width: 5.5rem;
}
.max-w-\\[560px\\] {
  max-width: 560px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[720px\\] {
  max-width: 720px;
}
.max-w-\\[840px\\] {
  max-width: 840px;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[88px\\] {
  max-width: 88px;
}
.max-w-\\[900px\\] {
  max-width: 900px;
}
.max-w-\\[920px\\] {
  max-width: 920px;
}
.max-w-\\[calc\\(100\\%-12px\\)\\] {
  max-width: calc(100% - 12px);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[16px\\] {
  flex: 16px 1;
}
.flex-\\[3\\] {
  flex: 3 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2 {
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-5 {
  --tw-translate-x: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[120\\%\\] {
  --tw-translate-x: -120%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[70\\%\\] {
  --tw-translate-x: -70%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[80\\%\\] {
  --tw-translate-x: -80%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[90\\%\\] {
  --tw-translate-x: -90%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[10\\%\\] {
  --tw-translate-y: 10%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[120\\%\\] {
  --tw-translate-y: 120%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[20\\%\\] {
  --tw-translate-y: 20%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[30\\%\\] {
  --tw-translate-y: 30%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.list-none {
  list-style-type: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-center {
  justify-items: center;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[6px\\] {
  gap: 6px;
}
.gap-\\[8px\\] {
  gap: 8px;
}
.gap-x-0 {
  column-gap: 0px;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[100px\\] {
  border-radius: 100px;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[15px\\] {
  border-radius: 15px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[18px\\] {
  border-radius: 18px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[50px\\] {
  border-radius: 50px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-\\[12px\\] {
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
}
.rounded-b-\\[15px\\] {
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-t-\\[12px\\] {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.rounded-t-\\[15px\\] {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.rounded-t-\\[24px\\] {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-2xl {
  border-bottom-left-radius: 1rem;
}
.rounded-br-2xl {
  border-bottom-right-radius: 1rem;
}
.rounded-tl-2xl {
  border-top-left-radius: 1rem;
}
.rounded-tr-2xl {
  border-top-right-radius: 1rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-\\[3px\\] {
  border-bottom-width: 3px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-\\[3px\\] {
  border-left-width: 3px;
}
.border-r-\\[3px\\] {
  border-right-width: 3px;
}
.border-s {
  border-inline-start-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-t-\\[3px\\] {
  border-top-width: 3px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-\\[\\#1e4570\\] {
  --tw-border-opacity: 1;
  border-color: rgb(30 69 112 / var(--tw-border-opacity, 1));
}
.border-\\[\\#276AA6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(39 106 166 / var(--tw-border-opacity, 1));
}
.border-\\[\\#4B5155\\] {
  --tw-border-opacity: 1;
  border-color: rgb(75 81 85 / var(--tw-border-opacity, 1));
}
.border-\\[\\#78D8C8\\]\\/85 {
  border-color: rgb(120 216 200 / 0.85);
}
.border-\\[\\#8FD0DC\\]\\/85 {
  border-color: rgb(143 208 220 / 0.85);
}
.border-\\[\\#969BA1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(150 155 161 / var(--tw-border-opacity, 1));
}
.border-\\[\\#A8B2D8\\]\\/85 {
  border-color: rgb(168 178 216 / 0.85);
}
.border-\\[\\#A8CCE8\\]\\/80 {
  border-color: rgb(168 204 232 / 0.8);
}
.border-\\[\\#A8DFC8\\]\\/85 {
  border-color: rgb(168 223 200 / 0.85);
}
.border-\\[\\#B8D898\\]\\/85 {
  border-color: rgb(184 216 152 / 0.85);
}
.border-\\[\\#C49AE8\\]\\/85 {
  border-color: rgb(196 154 232 / 0.85);
}
.border-\\[\\#C9BBF0\\]\\/85 {
  border-color: rgb(201 187 240 / 0.85);
}
.border-\\[\\#D4B8A8\\]\\/85 {
  border-color: rgb(212 184 168 / 0.85);
}
.border-\\[\\#E2E8F0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E8EEF5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(232 238 245 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EBEFF3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(235 239 243 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EEEEEE\\] {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F0F6FC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 246 252 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F56B23\\] {
  --tw-border-opacity: 1;
  border-color: rgb(245 107 35 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F5B8CC\\]\\/85 {
  border-color: rgb(245 184 204 / 0.85);
}
.border-\\[\\#F5D88A\\]\\/85 {
  border-color: rgb(245 216 138 / 0.85);
}
.border-\\[\\#FFCBB8\\]\\/90 {
  border-color: rgb(255 203 184 / 0.9);
}
.border-\\[\\#eeeeee\\] {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity, 1));
}
.border-cta {
  --tw-border-opacity: 1;
  border-color: rgb(255 106 75 / var(--tw-border-opacity, 1));
}
.border-cta\\/25 {
  border-color: rgb(255 106 75 / 0.25);
}
.border-cta\\/30 {
  border-color: rgb(255 106 75 / 0.3);
}
.border-cta\\/40 {
  border-color: rgb(255 106 75 / 0.4);
}
.border-cta\\/50 {
  border-color: rgb(255 106 75 / 0.5);
}
.border-darkBlue {
  --tw-border-opacity: 1;
  border-color: rgb(39 106 166 / var(--tw-border-opacity, 1));
}
.border-darkBlue\\/10 {
  border-color: rgb(39 106 166 / 0.1);
}
.border-darkBlue\\/15 {
  border-color: rgb(39 106 166 / 0.15);
}
.border-darkBlue\\/20 {
  border-color: rgb(39 106 166 / 0.2);
}
.border-darkBlue\\/25 {
  border-color: rgb(39 106 166 / 0.25);
}
.border-darkBlue\\/30 {
  border-color: rgb(39 106 166 / 0.3);
}
.border-lightBlue {
  --tw-border-opacity: 1;
  border-color: rgb(205 231 255 / var(--tw-border-opacity, 1));
}
.border-midGray {
  --tw-border-opacity: 1;
  border-color: rgb(75 81 85 / var(--tw-border-opacity, 1));
}
.border-secondary-green2\\/40 {
  border-color: rgb(37 179 143 / 0.4);
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-l-\\[\\#CDD5DC\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(205 213 220 / var(--tw-border-opacity, 1));
}
.border-l-darkBlue {
  --tw-border-opacity: 1;
  border-left-color: rgb(39 106 166 / var(--tw-border-opacity, 1));
}
.border-l-midGray {
  --tw-border-opacity: 1;
  border-left-color: rgb(75 81 85 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#007bff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 123 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#198754\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(25 135 84 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e293b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2563eb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#276AA6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(39 106 166 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#444444\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(68 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#888888\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(136 136 136 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8AC4F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(138 196 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#969BA1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(150 155 161 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B72000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(183 32 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#CC0000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#CDD5DC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(205 213 220 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#CDE7FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(205 231 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DCE8F3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 232 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E2E8F0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8EEF5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 238 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F4EC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 244 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EAF8F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 248 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBEFF3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 239 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0F6FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7FAFD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8FAFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8FAFD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFCFE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 252 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF6A4B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 106 75 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFE3E3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 227 227 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#cc0000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d8eafb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(216 234 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#dc2626\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eeeeee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff694b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 105 75 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/35 {
  background-color: rgb(0 0 0 / 0.35);
}
.bg-cta {
  --tw-bg-opacity: 1;
  background-color: rgb(255 106 75 / var(--tw-bg-opacity, 1));
}
.bg-cta\\/10 {
  background-color: rgb(255 106 75 / 0.1);
}
.bg-cta\\/5 {
  background-color: rgb(255 106 75 / 0.05);
}
.bg-darkBlue {
  --tw-bg-opacity: 1;
  background-color: rgb(39 106 166 / var(--tw-bg-opacity, 1));
}
.bg-darkBlue\\/0 {
  background-color: rgb(39 106 166 / 0);
}
.bg-darkBlue\\/10 {
  background-color: rgb(39 106 166 / 0.1);
}
.bg-darkBlue\\/15 {
  background-color: rgb(39 106 166 / 0.15);
}
.bg-darkBlue\\/5 {
  background-color: rgb(39 106 166 / 0.05);
}
.bg-darkBlue\\/85 {
  background-color: rgb(39 106 166 / 0.85);
}
.bg-darkBlue\\/90 {
  background-color: rgb(39 106 166 / 0.9);
}
.bg-lightBlue {
  --tw-bg-opacity: 1;
  background-color: rgb(205 231 255 / var(--tw-bg-opacity, 1));
}
.bg-lightCta {
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 252 / var(--tw-bg-opacity, 1));
}
.bg-lightCta\\/25 {
  background-color: rgb(240 246 252 / 0.25);
}
.bg-lightCta\\/40 {
  background-color: rgb(240 246 252 / 0.4);
}
.bg-lightCta\\/50 {
  background-color: rgb(240 246 252 / 0.5);
}
.bg-lightCta\\/60 {
  background-color: rgb(240 246 252 / 0.6);
}
.bg-lightCta\\/70 {
  background-color: rgb(240 246 252 / 0.7);
}
.bg-lightCta\\/80 {
  background-color: rgb(240 246 252 / 0.8);
}
.bg-midGray {
  --tw-bg-opacity: 1;
  background-color: rgb(75 81 85 / var(--tw-bg-opacity, 1));
}
.bg-secondary-green2\\/15 {
  background-color: rgb(37 179 143 / 0.15);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/25 {
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/35 {
  background-color: rgb(255 255 255 / 0.35);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/75 {
  background-color: rgb(255 255 255 / 0.75);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#276AA6\\] {
  --tw-gradient-from: #276AA6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(39 106 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#E5F7FA\\] {
  --tw-gradient-from: #E5F7FA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 247 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#E8F3FC\\] {
  --tw-gradient-from: #E8F3FC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(232 243 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#E8FCF8\\] {
  --tw-gradient-from: #E8FCF8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(232 252 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#EAF8F2\\] {
  --tw-gradient-from: #EAF8F2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 248 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ECEEF8\\] {
  --tw-gradient-from: #ECEEF8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 238 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#EEF4FB\\] {
  --tw-gradient-from: #EEF4FB var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 244 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#EEF5FC\\] {
  --tw-gradient-from: #EEF5FC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 245 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F0FAE8\\] {
  --tw-gradient-from: #F0FAE8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 250 232 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F2EEFF\\] {
  --tw-gradient-from: #F2EEFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(242 238 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F5E8FC\\] {
  --tw-gradient-from: #F5E8FC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 232 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FAF0E8\\] {
  --tw-gradient-from: #FAF0E8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 240 232 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFEDF2\\] {
  --tw-gradient-from: #FFEDF2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 237 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFF0EA\\] {
  --tw-gradient-from: #FFF0EA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 240 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFF8E6\\] {
  --tw-gradient-from: #FFF8E6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 248 230 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/85 {
  --tw-gradient-from: rgb(0 0 0 / 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cta {
  --tw-gradient-from: #FF6A4B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 106 75 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-darkBlue {
  --tw-gradient-from: #276AA6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(39 106 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lightCta {
  --tw-gradient-from: #F0F6FC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 246 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lightCta\\/90 {
  --tw-gradient-from: rgb(240 246 252 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 246 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/20 {
  --tw-gradient-from: rgb(255 255 255 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/25 {
  --tw-gradient-from: rgb(255 255 255 / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#3d8fd4\\] {
  --tw-gradient-to: rgb(61 143 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #3d8fd4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#C8EEF2\\] {
  --tw-gradient-to: rgb(200 238 242 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #C8EEF2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#C8F5EC\\] {
  --tw-gradient-to: rgb(200 245 236 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #C8F5EC var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#D4E8F8\\] {
  --tw-gradient-to: rgb(212 232 248 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #D4E8F8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#D8DCF0\\] {
  --tw-gradient-to: rgb(216 220 240 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #D8DCF0 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#D8F2E8\\] {
  --tw-gradient-to: rgb(216 242 232 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #D8F2E8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#E0F2D0\\] {
  --tw-gradient-to: rgb(224 242 208 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E0F2D0 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#E6DEFF\\] {
  --tw-gradient-to: rgb(230 222 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E6DEFF var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#E8D4F8\\] {
  --tw-gradient-to: rgb(232 212 248 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E8D4F8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#F0E0D4\\] {
  --tw-gradient-to: rgb(240 224 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F0E0D4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#F0F6FC\\] {
  --tw-gradient-to: rgb(240 246 252 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F0F6FC var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#F4F9FD\\] {
  --tw-gradient-to: rgb(244 249 253 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F4F9FD var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FF825E\\] {
  --tw-gradient-to: rgb(255 130 94 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FF825E var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FF8A6B\\] {
  --tw-gradient-to: rgb(255 138 107 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FF8A6B var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FFDEE8\\] {
  --tw-gradient-to: rgb(255 222 232 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FFDEE8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FFE4D9\\] {
  --tw-gradient-to: rgb(255 228 217 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FFE4D9 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FFEFCC\\] {
  --tw-gradient-to: rgb(255 239 204 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FFEFCC var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/25 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.25) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-darkBlue {
  --tw-gradient-to: rgb(39 106 166 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #276AA6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-lightCta\\/50 {
  --tw-gradient-to: rgb(240 246 252 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(240 246 252 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-lightCta\\/80 {
  --tw-gradient-to: rgb(240 246 252 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(240 246 252 / 0.8) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#1e3a5f\\] {
  --tw-gradient-to: #1e3a5f var(--tw-gradient-to-position);
}
.to-\\[\\#1e5280\\] {
  --tw-gradient-to: #1e5280 var(--tw-gradient-to-position);
}
.to-\\[\\#98E8D8\\] {
  --tw-gradient-to: #98E8D8 var(--tw-gradient-to-position);
}
.to-\\[\\#A8E0E8\\] {
  --tw-gradient-to: #A8E0E8 var(--tw-gradient-to-position);
}
.to-\\[\\#B8D9F0\\] {
  --tw-gradient-to: #B8D9F0 var(--tw-gradient-to-position);
}
.to-\\[\\#BEC5E4\\] {
  --tw-gradient-to: #BEC5E4 var(--tw-gradient-to-position);
}
.to-\\[\\#BEE8D4\\] {
  --tw-gradient-to: #BEE8D4 var(--tw-gradient-to-position);
}
.to-\\[\\#C5DCF2\\] {
  --tw-gradient-to: #C5DCF2 var(--tw-gradient-to-position);
}
.to-\\[\\#C8E4B0\\] {
  --tw-gradient-to: #C8E4B0 var(--tw-gradient-to-position);
}
.to-\\[\\#D4B8F0\\] {
  --tw-gradient-to: #D4B8F0 var(--tw-gradient-to-position);
}
.to-\\[\\#D4C8F5\\] {
  --tw-gradient-to: #D4C8F5 var(--tw-gradient-to-position);
}
.to-\\[\\#E0C8B8\\] {
  --tw-gradient-to: #E0C8B8 var(--tw-gradient-to-position);
}
.to-\\[\\#E8F2FA\\] {
  --tw-gradient-to: #E8F2FA var(--tw-gradient-to-position);
}
.to-\\[\\#FF825E\\] {
  --tw-gradient-to: #FF825E var(--tw-gradient-to-position);
}
.to-\\[\\#FFC8D8\\] {
  --tw-gradient-to: #FFC8D8 var(--tw-gradient-to-position);
}
.to-\\[\\#FFD0BC\\] {
  --tw-gradient-to: #FFD0BC var(--tw-gradient-to-position);
}
.to-\\[\\#FFE4A3\\] {
  --tw-gradient-to: #FFE4A3 var(--tw-gradient-to-position);
}
.to-darkBlue {
  --tw-gradient-to: #276AA6 var(--tw-gradient-to-position);
}
.to-lightCta\\/20 {
  --tw-gradient-to: rgb(240 246 252 / 0.2) var(--tw-gradient-to-position);
}
.to-lightCta\\/30 {
  --tw-gradient-to: rgb(240 246 252 / 0.3) var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-white\\/0 {
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
}
.to-white\\/5 {
  --tw-gradient-to: rgb(255 255 255 / 0.05) var(--tw-gradient-to-position);
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-none {
  object-fit: none;
}
.object-center {
  object-position: center;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[100px\\] {
  padding: 100px;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[15px\\] {
  padding: 15px;
}
.p-\\[16px\\] {
  padding: 16px;
}
.p-\\[1px\\] {
  padding: 1px;
}
.p-\\[20px\\] {
  padding: 20px;
}
.p-\\[24px\\] {
  padding: 24px;
}
.p-\\[2px\\] {
  padding: 2px;
}
.p-\\[30px\\] {
  padding: 30px;
}
.p-\\[32px\\] {
  padding: 32px;
}
.p-\\[35px\\] {
  padding: 35px;
}
.p-\\[3px\\] {
  padding: 3px;
}
.p-\\[40px\\] {
  padding: 40px;
}
.p-\\[50px\\] {
  padding: 50px;
}
.p-\\[5px\\] {
  padding: 5px;
}
.p-\\[8px\\] {
  padding: 8px;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[15px\\] {
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[200px\\] {
  padding-left: 200px;
  padding-right: 200px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[4px\\] {
  padding-left: 4px;
  padding-right: 4px;
}
.px-\\[50px\\] {
  padding-left: 50px;
  padding-right: 50px;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0px\\] {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[16px\\] {
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[25px\\] {
  padding-top: 25px;
  padding-bottom: 25px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[16px\\] {
  padding-bottom: 16px;
}
.pb-\\[4px\\] {
  padding-bottom: 4px;
}
.pb-\\[calc\\(5\\.5rem\\+env\\(safe-area-inset-bottom\\2c 0px\\)\\)\\] {
  padding-bottom: calc(5.5rem + env(safe-area-inset-bottom,0px));
}
.pb-\\[max\\(0\\.35rem\\2c env\\(safe-area-inset-bottom\\)\\)\\] {
  padding-bottom: max(0.35rem,env(safe-area-inset-bottom));
}
.pe-3 {
  padding-inline-end: 0.75rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-\\[10px\\] {
  padding-left: 10px;
}
.pl-\\[5px\\] {
  padding-left: 5px;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-\\[10px\\] {
  padding-right: 10px;
}
.pr-\\[5px\\] {
  padding-right: 5px;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[25px\\] {
  padding-top: 25px;
}
.pt-\\[5px\\] {
  padding-top: 5px;
}
.pt-\\[8px\\] {
  padding-top: 8px;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.font-Vazir-200 {
  font-family: Vazirmatn-200;
}
.font-Vazir-300 {
  font-family: Vazirmatn-300;
}
.font-Vazir-400 {
  font-family: Vazirmatn-400;
}
.font-Vazir-500 {
  font-family: Vazirmatn-500;
}
.font-Vazir-600 {
  font-family: Vazirmatn-600;
}
.font-Vazir-700 {
  font-family: Vazirmatn-700;
}
.font-Vazir-800 {
  font-family: Vazirmatn-800;
}
.font-Vazir-900 {
  font-family: Vazirmatn-900;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-9xl {
  font-size: 8rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[19px\\] {
  font-size: 19px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-\\[1\\.375rem\\] {
  line-height: 1.375rem;
}
.leading-\\[1\\.5\\] {
  line-height: 1.5;
}
.leading-\\[1\\.625rem\\] {
  line-height: 1.625rem;
}
.leading-\\[1\\.7\\] {
  line-height: 1.7;
}
.leading-\\[1\\.9\\] {
  line-height: 1.9;
}
.leading-\\[2\\.1\\] {
  line-height: 2.1;
}
.leading-\\[2\\] {
  line-height: 2;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.\\!text-white\\/55 {
  color: rgb(255 255 255 / 0.55) !important;
}
.text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#008000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 128 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#242424\\] {
  --tw-text-opacity: 1;
  color: rgb(36 36 36 / var(--tw-text-opacity, 1));
}
.text-\\[\\#25272A\\] {
  --tw-text-opacity: 1;
  color: rgb(37 39 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#276AA6\\] {
  --tw-text-opacity: 1;
  color: rgb(39 106 166 / var(--tw-text-opacity, 1));
}
.text-\\[\\#444444\\] {
  --tw-text-opacity: 1;
  color: rgb(68 68 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#475569\\] {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4B5155\\] {
  --tw-text-opacity: 1;
  color: rgb(75 81 85 / var(--tw-text-opacity, 1));
}
.text-\\[\\#64748B\\] {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-\\[\\#666666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#71767B\\] {
  --tw-text-opacity: 1;
  color: rgb(113 118 123 / var(--tw-text-opacity, 1));
}
.text-\\[\\#94A3B8\\] {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#969BA1\\] {
  --tw-text-opacity: 1;
  color: rgb(150 155 161 / var(--tw-text-opacity, 1));
}
.text-\\[\\#999999\\] {
  --tw-text-opacity: 1;
  color: rgb(153 153 153 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B72000\\] {
  --tw-text-opacity: 1;
  color: rgb(183 32 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#CDD5DC\\] {
  --tw-text-opacity: 1;
  color: rgb(205 213 220 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E1306C\\] {
  --tw-text-opacity: 1;
  color: rgb(225 48 108 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F56B23\\] {
  --tw-text-opacity: 1;
  color: rgb(245 107 35 / var(--tw-text-opacity, 1));
}
.text-\\[\\#aaaaaa\\] {
  --tw-text-opacity: 1;
  color: rgb(170 170 170 / var(--tw-text-opacity, 1));
}
.text-\\[\\#cc0000\\] {
  --tw-text-opacity: 1;
  color: rgb(204 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ffffff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-cta {
  --tw-text-opacity: 1;
  color: rgb(255 106 75 / var(--tw-text-opacity, 1));
}
.text-darkBlue {
  --tw-text-opacity: 1;
  color: rgb(39 106 166 / var(--tw-text-opacity, 1));
}
.text-darkBlue\\/25 {
  color: rgb(39 106 166 / 0.25);
}
.text-darkBlue\\/35 {
  color: rgb(39 106 166 / 0.35);
}
.text-darkBlue\\/40 {
  color: rgb(39 106 166 / 0.4);
}
.text-darkBlue\\/45 {
  color: rgb(39 106 166 / 0.45);
}
.text-darkBlue\\/50 {
  color: rgb(39 106 166 / 0.5);
}
.text-darkBlue\\/55 {
  color: rgb(39 106 166 / 0.55);
}
.text-darkBlue\\/60 {
  color: rgb(39 106 166 / 0.6);
}
.text-darkBlue\\/65 {
  color: rgb(39 106 166 / 0.65);
}
.text-darkBlue\\/70 {
  color: rgb(39 106 166 / 0.7);
}
.text-darkBlue\\/75 {
  color: rgb(39 106 166 / 0.75);
}
.text-darkBlue\\/80 {
  color: rgb(39 106 166 / 0.8);
}
.text-darkBlue\\/85 {
  color: rgb(39 106 166 / 0.85);
}
.text-darkBlue\\/90 {
  color: rgb(39 106 166 / 0.9);
}
.text-error {
  --tw-text-opacity: 1;
  color: rgb(183 32 0 / var(--tw-text-opacity, 1));
}
.text-grayText {
  --tw-text-opacity: 1;
  color: rgb(113 118 123 / var(--tw-text-opacity, 1));
}
.text-midGray {
  --tw-text-opacity: 1;
  color: rgb(75 81 85 / var(--tw-text-opacity, 1));
}
.text-secondary-green2 {
  --tw-text-opacity: 1;
  color: rgb(37 179 143 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/55 {
  color: rgb(255 255 255 / 0.55);
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75 {
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-35 {
  opacity: 0.35;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-\\[0\\.045\\] {
  opacity: 0.045;
}
.opacity-\\[40\\%\\] {
  opacity: 40%;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-6px_28px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 -6px 28px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 -6px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_28px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 10px 28px rgba(39,106,166,0.1);
  --tw-shadow-colored: 0 10px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 12px 32px rgba(39,106,166,0.15);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_32px_-20px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.22\\)\\] {
  --tw-shadow: 0 16px 32px -20px rgba(15,23,42,0.22);
  --tw-shadow-colored: 0 16px 32px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 1px 0 rgba(15,23,42,0.04);
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 1px 3px rgba(15,23,42,0.04);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_10px_rgba\\(255\\2c 105\\2c 75\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 2px 10px rgba(255,105,75,0.3);
  --tw-shadow-colored: 0 2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_12px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 2px 12px rgba(39,106,166,0.12);
  --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_12px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 2px 12px rgba(39,106,166,0.15);
  --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_rgba\\(255\\2c 106\\2c 75\\2c 0\\.35\\)\\] {
  --tw-shadow: 0 2px 8px rgba(255,106,75,0.35);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 2px 8px rgba(39,106,166,0.25);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 4px 12px rgba(39,106,166,0.12);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_rgba\\(255\\2c 106\\2c 75\\2c 0\\.35\\)\\] {
  --tw-shadow: 0 4px 14px rgba(255,106,75,0.35);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 4px 14px rgba(39,106,166,0.06);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_16px_rgba\\(255\\2c 106\\2c 75\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 4px 16px rgba(255,106,75,0.12);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_16px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 4px 16px rgba(39,106,166,0.06);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_16px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 4px 16px rgba(39,106,166,0.08);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 4px 20px rgba(39,106,166,0.06);
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.07\\)\\] {
  --tw-shadow: 0 4px 20px rgba(39,106,166,0.07);
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_24px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 4px 24px rgba(15,23,42,0.04);
  --tw-shadow-colored: 0 4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_20px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 6px 20px rgba(39,106,166,0.06);
  --tw-shadow-colored: 0 6px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_20px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 6px 20px rgba(39,106,166,0.25);
  --tw-shadow-colored: 0 6px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_18px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 8px 18px rgba(39,106,166,0.14);
  --tw-shadow-colored: 0 8px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(107\\2c 91\\2c 212\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(107,91,212,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(124\\2c 179\\2c 66\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(124,179,66,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(156\\2c 39\\2c 176\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(156,39,176,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(161\\2c 136\\2c 127\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(161,136,127,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(212\\2c 160\\2c 23\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(212,160,23,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(232\\2c 90\\2c 138\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(232,90,138,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(255\\2c 106\\2c 75\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(255,106,75,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(38\\2c 166\\2c 154\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(38,166,154,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 8px 20px rgba(39,106,166,0.12);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(52\\2c 215\\2c 173\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(52,215,173,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(59\\2c 168\\2c 188\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(59,168,188,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(92\\2c 107\\2c 192\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 20px rgba(92,107,192,0.1);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 8px 24px rgba(15,23,42,0.12);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 8px 24px rgba(39,106,166,0.08);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.18\\)\\] {
  --tw-shadow: 0 8px 24px rgba(39,106,166,0.18);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_32px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 8px 32px rgba(39,106,166,0.08);
  --tw-shadow-colored: 0 8px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_32px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 8px 32px rgba(39,106,166,0.12);
  --tw-shadow-colored: 0 8px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-\\[\\#E2E8F0\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-cta {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 106 75 / var(--tw-ring-opacity, 1));
}
.ring-cta\\/20 {
  --tw-ring-color: rgb(255 106 75 / 0.2);
}
.ring-darkBlue\\/10 {
  --tw-ring-color: rgb(39 106 166 / 0.1);
}
.ring-darkBlue\\/15 {
  --tw-ring-color: rgb(39 106 166 / 0.15);
}
.ring-lightCta {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 246 252 / var(--tw-ring-opacity, 1));
}
.ring-secondary-green2\\/30 {
  --tw-ring-color: rgb(37 179 143 / 0.3);
}
.ring-white\\/30 {
  --tw-ring-color: rgb(255 255 255 / 0.3);
}
.ring-white\\/90 {
  --tw-ring-color: rgb(255 255 255 / 0.9);
}
.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\2c box-shadow\\] {
  transition-property: border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
html,
body,
#root {
  background-color: #F0F6FC;
  max-width: 100%;
  overflow-x: hidden;
}

body {
  direction: rtl;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Home expertise: knock out white PNG matte on colored circles */
.expertise-home-icon {
  mix-blend-mode: multiply;
  filter: contrast(1.06) brightness(0.98);
}

/* TipTap / publication article body */
.publication-content {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  display: flow-root;
  overflow-wrap: anywhere;
}

.publication-content h1,
.publication-content h2,
.publication-content h3 {
  margin-top: 1.25em;
  margin-bottom: 0.5em;
  font-family: inherit;
  font-weight: 700;
  color: #1a3a5c;
}

.publication-content h1 { font-size: 1.35rem; }
.publication-content h2 { font-size: 1.2rem; }
.publication-content h3 { font-size: 1.05rem; }

.publication-content p {
  margin-bottom: 0.85em;
}

.publication-content a {
  color: #ff694b;
  text-decoration: underline;
}

.publication-content ul,
.publication-content ol {
  margin: 0.75em 0;
  padding-right: 1.25em;
}

.publication-content img,
.publication-content video,
.publication-content iframe {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  margin: 1em auto;
}

.publication-content table {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}

.publication-content blockquote {
  margin: 1em 0;
  padding: 0.75em 1em;
  border-right: 3px solid #cde7ff;
  background: #f0f6fc;
  border-radius: 8px;
}

.placeholder\\:text-darkBlue\\/35::placeholder {
  color: rgb(39 106 166 / 0.35);
}

.placeholder\\:text-darkBlue\\/40::placeholder {
  color: rgb(39 106 166 / 0.4);
}

.focus-within\\:border-cta\\/70:focus-within {
  border-color: rgb(255 106 75 / 0.7);
}

.focus-within\\:shadow-\\[0_0_0_3px_rgba\\(255\\2c 106\\2c 75\\2c 0\\.15\\)\\]:focus-within {
  --tw-shadow: 0 0 0 3px rgba(255,106,75,0.15);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:border-\\[\\#276AA6\\]\\/30:hover {
  border-color: rgb(39 106 166 / 0.3);
}

.hover\\:border-cta:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 106 75 / var(--tw-border-opacity, 1));
}

.hover\\:border-cta\\/40:hover {
  border-color: rgb(255 106 75 / 0.4);
}

.hover\\:border-cta\\/50:hover {
  border-color: rgb(255 106 75 / 0.5);
}

.hover\\:border-darkBlue\\/20:hover {
  border-color: rgb(39 106 166 / 0.2);
}

.hover\\:border-darkBlue\\/25:hover {
  border-color: rgb(39 106 166 / 0.25);
}

.hover\\:border-darkBlue\\/30:hover {
  border-color: rgb(39 106 166 / 0.3);
}

.hover\\:border-darkBlue\\/35:hover {
  border-color: rgb(39 106 166 / 0.35);
}

.hover\\:bg-\\[\\#1d4ed8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1e4570\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 69 112 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1e5a8a\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 90 138 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#D4E3F0\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(212 227 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#E0EEF8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 238 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#b91c1c\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cta\\/10:hover {
  background-color: rgb(255 106 75 / 0.1);
}

.hover\\:bg-cta\\/90:hover {
  background-color: rgb(255 106 75 / 0.9);
}

.hover\\:bg-darkBlue\\/10:hover {
  background-color: rgb(39 106 166 / 0.1);
}

.hover\\:bg-lightBlue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(205 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-lightCta:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-lightCta\\/70:hover {
  background-color: rgb(240 246 252 / 0.7);
}

.hover\\:bg-lightCta\\/80:hover {
  background-color: rgb(240 246 252 / 0.8);
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:text-\\[\\#164785\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(22 71 133 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#cc0000\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(204 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-cta:hover {
  --tw-text-opacity: 1;
  color: rgb(255 106 75 / var(--tw-text-opacity, 1));
}

.hover\\:text-darkBlue:hover {
  --tw-text-opacity: 1;
  color: rgb(39 106 166 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:opacity-95:hover {
  opacity: 0.95;
}

.hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_2px_12px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.12\\)\\]:hover {
  --tw-shadow: 0 2px 12px rgba(39,106,166,0.12);
  --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_4px_12px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.08\\)\\]:hover {
  --tw-shadow: 0 4px 12px rgba(39,106,166,0.08);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:brightness-105:hover {
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.focus\\:border-\\[\\#444444\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(68 68 68 / var(--tw-border-opacity, 1));
}

.focus\\:border-darkBlue\\/35:focus {
  border-color: rgb(39 106 166 / 0.35);
}

.focus\\:border-darkBlue\\/40:focus {
  border-color: rgb(39 106 166 / 0.4);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-cta\\/15:focus {
  --tw-ring-color: rgb(255 106 75 / 0.15);
}

.focus\\:ring-cta\\/30:focus {
  --tw-ring-color: rgb(255 106 75 / 0.3);
}

.focus\\:ring-darkBlue\\/10:focus {
  --tw-ring-color: rgb(39 106 166 / 0.1);
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-cta\\/30:focus-visible {
  --tw-ring-color: rgb(255 106 75 / 0.3);
}

.focus-visible\\:ring-cta\\/40:focus-visible {
  --tw-ring-color: rgb(255 106 75 / 0.4);
}

.focus-visible\\:ring-darkBlue\\/20:focus-visible {
  --tw-ring-color: rgb(39 106 166 / 0.2);
}

.focus-visible\\:ring-darkBlue\\/25:focus-visible {
  --tw-ring-color: rgb(39 106 166 / 0.25);
}

.focus-visible\\:ring-darkBlue\\/30:focus-visible {
  --tw-ring-color: rgb(39 106 166 / 0.3);
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.active\\:scale-\\[0\\.97\\]:active {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.99\\]:active {
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:opacity-0:disabled {
  opacity: 0;
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.group:hover .group-hover\\:-translate-y-0\\.5 {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.01\\] {
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.03\\] {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.04\\] {
  --tw-scale-x: 1.04;
  --tw-scale-y: 1.04;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-\\[\\#26A69A\\]\\/40 {
  border-color: rgb(38 166 154 / 0.4);
}

.group:hover .group-hover\\:border-\\[\\#3BA8BC\\]\\/40 {
  border-color: rgb(59 168 188 / 0.4);
}

.group:hover .group-hover\\:border-\\[\\#5C6BC0\\]\\/40 {
  border-color: rgb(92 107 192 / 0.4);
}

.group:hover .group-hover\\:border-\\[\\#7CB342\\]\\/40 {
  border-color: rgb(124 179 66 / 0.4);
}

.group:hover .group-hover\\:border-\\[\\#8B7AE8\\]\\/45 {
  border-color: rgb(139 122 232 / 0.45);
}

.group:hover .group-hover\\:border-\\[\\#9C27B0\\]\\/35 {
  border-color: rgb(156 39 176 / 0.35);
}

.group:hover .group-hover\\:border-\\[\\#A1887F\\]\\/40 {
  border-color: rgb(161 136 127 / 0.4);
}

.group:hover .group-hover\\:border-\\[\\#D4A017\\]\\/40 {
  border-color: rgb(212 160 23 / 0.4);
}

.group:hover .group-hover\\:border-\\[\\#E85A8A\\]\\/40 {
  border-color: rgb(232 90 138 / 0.4);
}

.group:hover .group-hover\\:border-cta\\/40 {
  border-color: rgb(255 106 75 / 0.4);
}

.group:hover .group-hover\\:border-darkBlue\\/20 {
  border-color: rgb(39 106 166 / 0.2);
}

.group:hover .group-hover\\:border-darkBlue\\/35 {
  border-color: rgb(39 106 166 / 0.35);
}

.group:hover .group-hover\\:border-secondary-green2\\/45 {
  border-color: rgb(37 179 143 / 0.45);
}

.group:hover .group-hover\\:bg-darkBlue\\/15 {
  background-color: rgb(39 106 166 / 0.15);
}

.group:hover .group-hover\\:bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:text-cta {
  --tw-text-opacity: 1;
  color: rgb(255 106 75 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-darkBlue {
  --tw-text-opacity: 1;
  color: rgb(39 106 166 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(107\\2c 91\\2c 212\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(107,91,212,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(124\\2c 179\\2c 66\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(124,179,66,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(156\\2c 39\\2c 176\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(156,39,176,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(161\\2c 136\\2c 127\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(161,136,127,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(212\\2c 160\\2c 23\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(212,160,23,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(232\\2c 90\\2c 138\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(232,90,138,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(255\\2c 106\\2c 75\\2c 0\\.16\\)\\] {
  --tw-shadow: 0 12px 28px rgba(255,106,75,0.16);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(37\\2c 179\\2c 143\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(37,179,143,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(38\\2c 166\\2c 154\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(38,166,154,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.18\\)\\] {
  --tw-shadow: 0 12px 28px rgba(39,106,166,0.18);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(59\\2c 168\\2c 188\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(59,168,188,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_28px_rgba\\(92\\2c 107\\2c 192\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 12px 28px rgba(92,107,192,0.14);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_12px_32px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.22\\)\\] {
  --tw-shadow: 0 12px 32px rgba(39,106,166,0.22);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_20px_36px_-18px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.28\\)\\] {
  --tw-shadow: 0 20px 36px -18px rgba(39,106,166,0.28);
  --tw-shadow-colored: 0 20px 36px -18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_2px_10px_rgba\\(255\\2c 106\\2c 75\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 2px 10px rgba(255,106,75,0.12);
  --tw-shadow-colored: 0 2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-\\[0_8px_24px_rgba\\(39\\2c 106\\2c 166\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 8px 24px rgba(39,106,166,0.12);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.peer:focus ~ .peer-focus\\:text-darkBlue\\/70 {
  color: rgb(39 106 166 / 0.7);
}

@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:animate-none {
    animation: none;
  }
}

@media (max-width: 640px) {

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .sm\\:-mb-5 {
    margin-bottom: -1.25rem;
  }

  .sm\\:-mt-5 {
    margin-top: -1.25rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:aspect-\\[1\\.35\\/1\\] {
    aspect-ratio: 1.35/1;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-\\[200px\\] {
    height: 200px;
  }

  .sm\\:h-\\[260px\\] {
    height: 260px;
  }

  .sm\\:h-\\[58px\\] {
    height: 58px;
  }

  .sm\\:w-14 {
    width: 3.5rem;
  }

  .sm\\:w-\\[132px\\] {
    width: 132px;
  }

  .sm\\:w-\\[calc\\(\\(100\\%-0\\.75rem\\)\\/2\\)\\] {
    width: calc((100% - 0.75rem) / 2);
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-\\[260px\\] {
    min-width: 260px;
  }

  .sm\\:min-w-\\[280px\\] {
    min-width: 280px;
  }

  .sm\\:max-w-\\[220px\\] {
    max-width: 220px;
  }

  .sm\\:max-w-\\[260px\\] {
    max-width: 260px;
  }

  .sm\\:shrink-0 {
    flex-shrink: 0;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:items-stretch {
    align-items: stretch;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-\\[22px\\] {
    font-size: 22px;
  }
}

@media (max-width: 768px) {

  .md\\:left-1 {
    left: 0.25rem;
  }

  .md\\:right-1 {
    right: 0.25rem;
  }

  .md\\:right-8 {
    right: 2rem;
  }

  .md\\:top-8 {
    top: 2rem;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .md\\:mb-\\[5px\\] {
    margin-bottom: 5px;
  }

  .md\\:mt-3 {
    margin-top: 0.75rem;
  }

  .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  .md\\:mt-\\[10px\\] {
    margin-top: 10px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:h-11 {
    height: 2.75rem;
  }

  .md\\:h-\\[280px\\] {
    height: 280px;
  }

  .md\\:h-\\[340px\\] {
    height: 340px;
  }

  .md\\:h-\\[480px\\] {
    height: 480px;
  }

  .md\\:h-\\[70px\\] {
    height: 70px;
  }

  .md\\:w-11 {
    width: 2.75rem;
  }

  .md\\:w-\\[250px\\] {
    width: 250px;
  }

  .md\\:w-\\[70px\\] {
    width: 70px;
  }

  .md\\:w-\\[calc\\(\\(100\\%-1\\.5rem\\)\\/3\\)\\] {
    width: calc((100% - 1.5rem) / 3);
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:max-w-\\[380px\\] {
    max-width: 380px;
  }

  .md\\:max-w-\\[6\\.5rem\\] {
    max-width: 6.5rem;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_300px\\] {
    grid-template-columns: minmax(0,1fr) 300px;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:space-y-10 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
  }

  .md\\:rounded-\\[0px\\] {
    border-radius: 0px;
  }

  .md\\:rounded-\\[20px\\] {
    border-radius: 20px;
  }

  .md\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:p-\\[10px\\] {
    padding: 10px;
  }

  .md\\:p-\\[32px\\] {
    padding: 32px;
  }

  .md\\:p-\\[40px\\] {
    padding: 40px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:pt-8 {
    padding-top: 2rem;
  }

  .md\\:font-Vazir-700 {
    font-family: Vazirmatn-700;
  }

  .md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .md\\:text-\\[17px\\] {
    font-size: 17px;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .md\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .md\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .md\\:text-\\[28px\\] {
    font-size: 28px;
  }
}

@media (max-width: 1024px) {

  .lg\\:fixed {
    position: fixed;
  }

  .lg\\:inset-auto {
    inset: auto;
  }

  .lg\\:bottom-0 {
    bottom: 0px;
  }

  .lg\\:bottom-\\[60px\\] {
    bottom: 60px;
  }

  .lg\\:left-0 {
    left: 0px;
  }

  .lg\\:top-\\[110px\\] {
    top: 110px;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mx-\\[0px\\] {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mx-\\[15px\\] {
    margin-left: 15px;
    margin-right: 15px;
  }

  .lg\\:mx-\\[16px\\] {
    margin-left: 16px;
    margin-right: 16px;
  }

  .lg\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .lg\\:my-\\[15px\\] {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .lg\\:my-\\[5px\\] {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .lg\\:mb-\\[12px\\] {
    margin-bottom: 12px;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:mr-0 {
    margin-right: 0px;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-2 {
    margin-top: 0.5rem;
  }

  .lg\\:mt-5 {
    margin-top: 1.25rem;
  }

  .lg\\:mt-\\[10px\\] {
    margin-top: 10px;
  }

  .lg\\:mt-\\[15px\\] {
    margin-top: 15px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[180px\\] {
    height: 180px;
  }

  .lg\\:h-\\[50px\\] {
    height: 50px;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:w-\\[200px\\] {
    width: 200px;
  }

  .lg\\:w-\\[330px\\] {
    width: 330px;
  }

  .lg\\:w-\\[50px\\] {
    width: 50px;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:translate-y-0 {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-0 {
    gap: 0px;
  }

  .lg\\:gap-1 {
    gap: 0.25rem;
  }

  .lg\\:gap-\\[10px\\] {
    gap: 10px;
  }

  .lg\\:gap-\\[4px\\] {
    gap: 4px;
  }

  .lg\\:rounded-\\[10px\\] {
    border-radius: 10px;
  }

  .lg\\:rounded-\\[12px\\] {
    border-radius: 12px;
  }

  .lg\\:rounded-none {
    border-radius: 0px;
  }

  .lg\\:rounded-b-none {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .lg\\:border-0 {
    border-width: 0px;
  }

  .lg\\:bg-\\[\\#F0F6FC\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 246 252 / var(--tw-bg-opacity, 1));
  }

  .lg\\:bg-\\[\\#F7FAFD\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(247 250 253 / var(--tw-bg-opacity, 1));
  }

  .lg\\:bg-\\[\\#f0f6fc\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 246 252 / var(--tw-bg-opacity, 1));
  }

  .lg\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .lg\\:p-0 {
    padding: 0px;
  }

  .lg\\:p-2 {
    padding: 0.5rem;
  }

  .lg\\:p-6 {
    padding: 1.5rem;
  }

  .lg\\:p-\\[15px\\] {
    padding: 15px;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:px-\\[15px\\] {
    padding-left: 15px;
    padding-right: 15px;
  }

  .lg\\:px-\\[16px\\] {
    padding-left: 16px;
    padding-right: 16px;
  }

  .lg\\:text-right {
    text-align: right;
  }

  .lg\\:font-Vazir-400 {
    font-family: Vazirmatn-400;
  }
}

@media (max-width: 1280px) {

  .xl\\:block {
    display: block;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:w-\\[300px\\] {
    width: 300px;
  }
}

.\\[\\&\\>\\*\\]\\:h-full>* {
  height: 100%;
}

.\\[\\&\\>\\*\\]\\:min-w-0>* {
  min-width: 0px;
}

.\\[\\&_input\\]\\:pl-14 input {
  padding-left: 3.5rem;
}

.\\[\\&_path\\]\\:stroke-secondary-green2 path {
  stroke: #25B38F;
}

.\\[\\&_path\\]\\:stroke-white path {
  stroke: #fff;
}

.\\[\\&_rect\\]\\:stroke-secondary-green2 rect {
  stroke: #25B38F;
}

.\\[\\&_span\\]\\:\\!text-\\[9px\\] span {
  font-size: 9px !important;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAEnB;;;EAGE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,iEAAiE;AACjE;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;EAGE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B,kBAAkB,EAAE;AAC9C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,kBAAkB,EAAE;;AAE9C;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AA5FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,4CA8FA;EA9FA,qDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,sBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,oBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,oBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,oBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,oBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,0EA8FA;EA9FA,8FA8FA;EA9FA;AA8FA;;AA9FA;EAAA,6CA8FA;EA9FA,sDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,6CA8FA;EA9FA,sDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,+EA8FA;EA9FA,mGA8FA;EA9FA;AA8FA;;AA9FA;EAAA,6EA8FA;EA9FA,iGA8FA;EA9FA;AA8FA;;AA9FA;EAAA,iCA8FA;EA9FA;AA8FA;;AA9FA;EAAA,sBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,8BA8FA;EA9FA;AA8FA;;AA9FA;EAAA,2GA8FA;EA9FA,yGA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,8BA8FA;EA9FA;AA8FA;;AA9FA;EAAA,2GA8FA;EA9FA,yGA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,2BA8FA;EA9FA;AA8FA;;AA9FA;EAAA,0BA8FA;EA9FA;AA8FA;;AA9FA;EAAA,eA8FA;EA9FA,eA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,kBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,oBA8FA;EA9FA;AA8FA;;AA9FA;EAAA,oBA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,+CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,8CA8FA;EA9FA,uDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,oDA8FA;EA9FA,6DA8FA;EA9FA;AA8FA;;AA9FA;EAAA,6CA8FA;EA9FA,sDA8FA;EA9FA;AA8FA;;AA9FA;EAAA,6CA8FA;EA9FA,sDA8FA;EA9FA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;;EAAA;IAAA;EA8FA;AAAA;;AA9FA;;EAAA;IAAA;EA8FA;;EA9FA;IAAA,qBA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,oBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,mBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,iBA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;AAAA;;AA9FA;;EAAA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,gBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,iBA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,uBA8FA;IA9FA,8DA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,oBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,oBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,qBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,kBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,oBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,iBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,oBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,mBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,oBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,iBA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;AAAA;;AA9FA;;EAAA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,gBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,gBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,iBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,iBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,eA8FA;IA9FA;EA8FA;;EA9FA;IAAA,gBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,eA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,qBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,qBA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,+BA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,kBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,kBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,kBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,kBA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA,iBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,kBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,kBA8FA;IA9FA;EA8FA;;EA9FA;IAAA,kBA8FA;IA9FA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;AAAA;;AA9FA;;EAAA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;;EA9FA;IAAA;EA8FA;AAAA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA;;AA9FA;EAAA;AA8FA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import './assets/Vazirmatn-font-face.css';\nhtml,\nbody,\n#root {\n  background-color: #F0F6FC;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\nbody {\n  direction: rtl;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Home expertise: knock out white PNG matte on colored circles */\n.expertise-home-icon {\n  mix-blend-mode: multiply;\n  filter: contrast(1.06) brightness(0.98);\n}\n\n/* TipTap / publication article body */\n.publication-content {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  display: flow-root;\n  overflow-wrap: anywhere;\n}\n\n.publication-content h1,\n.publication-content h2,\n.publication-content h3 {\n  margin-top: 1.25em;\n  margin-bottom: 0.5em;\n  font-family: inherit;\n  font-weight: 700;\n  color: #1a3a5c;\n}\n\n.publication-content h1 { font-size: 1.35rem; }\n.publication-content h2 { font-size: 1.2rem; }\n.publication-content h3 { font-size: 1.05rem; }\n\n.publication-content p {\n  margin-bottom: 0.85em;\n}\n\n.publication-content a {\n  color: #ff694b;\n  text-decoration: underline;\n}\n\n.publication-content ul,\n.publication-content ol {\n  margin: 0.75em 0;\n  padding-right: 1.25em;\n}\n\n.publication-content img,\n.publication-content video,\n.publication-content iframe {\n  max-width: 100%;\n  height: auto;\n  border-radius: 10px;\n  margin: 1em auto;\n}\n\n.publication-content table {\n  display: block;\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.publication-content blockquote {\n  margin: 1em 0;\n  padding: 0.75em 1em;\n  border-right: 3px solid #cde7ff;\n  background: #f0f6fc;\n  border-radius: 8px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
